import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";
import { IPricing } from "@/app/domain";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";

export class HalfInstallationSumCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent, [priceWithDiscount, overChargeSum, isOverchargeSelected]): PriceResult {
        if (!priceWithDiscount) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculateHalfInstallationSum(
                priceWithDiscount, overChargeSum, isOverchargeSelected,
                CostDealType,
            ),
            priceB2C: this.calculateHalfInstallationSum(
                priceWithDiscount, overChargeSum, isOverchargeSelected,
                B2CDealType,
            ),
            priceB2B: this.calculateHalfInstallationSum(
                priceWithDiscount, overChargeSum, isOverchargeSelected,
                B2BDealType,
            ),
        };
    }

    private calculateHalfInstallationSum(
        priceWithDiscount: IPricing,
        overChargeSum: number,
        isOverchargeSelected: boolean,
        dealType: string,
    ) {
        if (isOverchargeSelected) {
            const installationSum = priceWithDiscount.getSystemPrice(dealType).getValue() + overChargeSum;
            return installationSum / 2;
        }

        return priceWithDiscount.getSystemPrice(dealType).getValue() / 2;
    }
}
